import {sharedPasswordValidator} from '@shared/custom-validators/shared-custom-validator-password.validator';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {SharedModalControllerService} from "@shared/services/shared-modal-controller.service";
import {IonicModule} from "@ionic/angular";

import {TranslatePipe} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {SharedShowHidePasswordComponent} from "@shared/components/show-hide-password/shared-show-hide-password.component";
import {sharedPasswordMatchValidator} from "@shared/custom-validators/shared-custom-validator-passwords-match.validator";

@Component({
  selector: 'app-team-login-register-user-form',
  templateUrl: './team-login-register-user-form.component.html',
  styleUrls: ['./team-login-register-user-form.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    SharedShowHidePasswordComponent
],
  standalone: true
})
export class TeamLoginRegisterUserFormComponent implements OnInit {
  private _sharedModalControllerService = inject(SharedModalControllerService);
  formBuilder = inject(FormBuilder);


  @Input() existingEmail: string;
  registerUserForm: FormGroup;
  @Output() formChange: EventEmitter<FormGroup>;
  @Output() submitChange: EventEmitter<FormGroup>;

  constructor() {
    this.existingEmail = "";
    this.registerUserForm = new FormGroup({});
    this.formChange = new EventEmitter<FormGroup>();
    this.submitChange = new EventEmitter<FormGroup>();
  }

  getControl(controlName: string) {
    return this.registerUserForm.get(controlName) as FormControl;
  }

  ngOnInit() {
    this.initializeRegisterPasswordForm();
    this.registerUserForm.valueChanges.subscribe(() => {
      this.formChange.emit(this.registerUserForm);
    });
  }

  /**
   * @name initializeRegisterPasswordForm
   * @description
   * init register password form
   * @memberof TeamLoginRegisterUserFormComponent
   */
  initializeRegisterPasswordForm() {
    this.registerUserForm = this.formBuilder.group({
      email: [this.existingEmail ? this.existingEmail : "", Validators.required],
      password: ['', sharedPasswordValidator],
      confirmPassword: ['', sharedPasswordValidator],
    }, { validators: [sharedPasswordMatchValidator('password', 'confirmPassword')] });
  }

  /**
   * @name exit
   * @description
   * close the modal
   * @memberof TeamLoginRegisterUserFormComponent
   */
  exit(): void {
    this._sharedModalControllerService.closeModal();
  }

  /**
   * @name submitForm
   * @description
   * emit the changes
   * @memberof TeamLoginRegisterUserFormComponent
   */
  submitForm() {
    if (this.registerUserForm.valid) {
      this.submitChange.emit(this.registerUserForm);
    }
  }

  /**
   * @name formatPin
   * @description
   * format the pin to a full number
   * @memberof TeamLoginRegisterUserFormComponent
   * @param pinArray
   * @returns {number}
   */
  formatPin(pinArray: number[]): number {
    return parseInt(pinArray.join(''));
  }

  /**
   * @name isRequired
   * @description
   * check if a control is required
   * @memberof TeamLoginRegisterUserFormComponent
   * @param controlName
   */
  isRequired(controlName: string): boolean {
    const control = this.registerUserForm.get(controlName);
    if (control) {
      const validator = control.validator ? control.validator({} as any) : null;
      return !!(validator && validator['required']);
    }
    return false;
  }
}
